import { FC } from "react";
import { Outlet } from "react-router-dom";

import { ErrorBoundary } from "@dzambalaorg/mui-page-layout";
import { GlobalFormDialog, GlobalViewDialog } from "@framework/shared";
import { AppShellLayout } from "@dzambalaorg/ui-kit";

import { officeGlobalDialogComponentsSchema } from "../../../shared";
import { Header } from "../header";

export const Layout: FC = () => {
  return (
    <AppShellLayout header={<Header />}>
      <AppShellLayout.Main>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </AppShellLayout.Main>
      <GlobalFormDialog externalDialogComponentSchema={officeGlobalDialogComponentsSchema} />
      <GlobalViewDialog />
    </AppShellLayout>
  );
};
